module.exports = __webpack_public_path__ + "img/ptIcon.625a3ff3.svg";